import { useEffect } from 'react';
import { useToast } from '../../hooks/useAppToast';
import { CONTEXT_NOTICE_KEY } from '../../lib/contextMismatch';

/**
 * 会社・店の食い違い（サーバの 409）で画面を読み直したとき、読み直した後の画面に理由を 1 回だけ出す（2026-10-17）。
 * 読み直す前に出すと、読み直しで消えて誰にも見えない。
 */
export function ContextReloadNotice(): null {
  const toast = useToast();

  useEffect(() => {
    let message: string | null = null;
    try {
      message = sessionStorage.getItem(CONTEXT_NOTICE_KEY);
      if (message) sessionStorage.removeItem(CONTEXT_NOTICE_KEY);
    } catch { /* 読めなければ出さない */ }
    if (message) {
      toast({ status: 'info', title: message, duration: 6000, isClosable: true });
    }
  }, [toast]);

  return null;
}
